import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Select, Col, Row, DatePicker, Upload, Avatar, notification, Button, TimePicker } from 'antd';
import propTypes from 'prop-types';
import { Modal } from '../../components/modals/antd-modals';
import { FileImageOutlined } from '@ant-design/icons';
import { BasicFormWrapper } from '../styled';
import config from '../../config/config';
import moment from 'moment';
import messages from '../../config/constants/messages';

import axios from 'axios';
import PhoneInput from 'react-phone-input-2'
import FeatherIcon from 'feather-icons-react';
import 'react-phone-input-2/lib/style.css'
import GetSnippetsData from '../profile/authentication/overview/Snippets/GetSnippetsData';


const { TextArea } = Input;

const EditMerchant = ({ visible, onCancel, Id }) => {

    const dispatch = useDispatch();


    const [form] = Form.useForm();
    
    //const [is_framed, setIsFramed] = useState(false);
    const role = "City"
    const snippetData = GetSnippetsData(role)

    const [state, setState] = useState({
        uid: Id,
        i_am: '',
        name: '',
        user_type: '',
        email: '',
        phone: '',
        city: '',
        address: '',
        country: '',
        logo: [],
    });


    const [description_data, SetDescription] = useState("")
    const [phone, setPhone] = useState('')
    const [bio, SetBio] = useState("")

    const [namelength, setNamelength] = useState(0)
    const [biolength, setBiolength] = useState(0)

    const [buttonDisable, setButton] = useState(false);
    const [loading, setLoading] = useState(false);


    const [editData, setEditData] = useState(null);
    const [ShowForm, setShowForm] = useState(false);



    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            setState({
                visible,
            });
        }
        return () => {
            unmounted = true;
        };
    }, [visible]);

    useEffect(() => {

        sessionStorage.removeItem('tab-index');

        const getMerchant = async () => {

            const response = await fetch(`${config.apiUrl}/get-user-logo/${Id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            const data = await response.json();

            if (data[0]) {
                setEditData(data[0])
                setPhone(data[0].phone);
                var len = data[0].name;
                setNamelength(len.length);
                var len1 = data[0].bio;
                setBiolength(len1.length);
            }
            setShowForm(true);
        }
        getMerchant();

    }, [])

    const handleCountryCode = (value, data, event, formattedValue) => {
        setPhone(formattedValue)
    }

    const handleOk = (values) => {
        let old_email = editData.email;
        //alert(JSON.stringify(newObj));return false;

        const promise = new Promise((resolve, reject) => {
            if (old_email != values.email) {
                let check_email = { email: values.email };
                axios.post(`${config.apiUrl}/check-exsting-email`, check_email)
                    .then(function (response) {
                        if (response.data[0].status == true) {
                            alert("This " + email + " already registered as different account");
                            return false;
                        } else {
                            resolve(true);
                        }
                    })
                    .catch(function (error) {
                        alert("Sorry, something went wrong");
                        return false;
                    });
            } else {
                resolve(true);
            }
        })
        promise.then((d) => {
            const formData = new FormData();

            var newObj = {
                ...values,
                uid: editData.uid,
                i_am: editData.i_am,
                old_email: old_email,
                old_password: editData.password,
                phone: phone ? phone : '',
                address: editData.address,
                country: 'usa',
                is_visiable:0
            };

            if (state.logo) {
                for (let i = 0; i < state.logo.length; i++) {
                    formData.append('file', state.logo[i])
                }
            }

            formData.append('data', JSON.stringify(newObj))

            axios.post(`${config.apiUrl}/update-admin-artistprofile`, formData)
                .then((response) => {
                    sessionStorage.setItem('user_address', newObj.address);
                    if (response.data.affectedRows == 1) {
                        notification.success({
                            message: messages['update_profile_success'],
                        });
                        onCancel();
                    }
                })
                .catch((error) => {
                    console.log("Error :", error)
                })
        })
    };

    const handleCancel = () => {
        onCancel();
    };

    const assign_bio = data => {	
		setBiolength(data.length)
		SetBio(data);
	};


    return (

        <>

            <Modal
                type={state.modalType}
                title="Edit Merchant"
                visible={state.visible}
                width={1000}
                backdrop="static"
                footer={[null]}
                onCancel={handleCancel}
            >
                <div className="project-modal">
                    {ShowForm == true &&
                        <>
                            <BasicFormWrapper>
                                <Form id="createWorkForm" form={form} name="createProject" onFinish={handleOk} encType="multipart/form-data">

                                    <Form.Item label="Name" name="name" rules={[
                                        { required: true, message: 'Please input your full name' },
                                        { max: 100, message: "The maximum length for the full name is 100 characters." }
                                    ]}
                                        initialValue={editData ? editData.name : ''}
                                    >
                                        <Input placeholder="Full name"
                                            onChange={(e) => {
                                                var temp = e.target.value;
                                                setNamelength(temp.length);
                                            }
                                            }
                                        />
                                    </Form.Item>
                                    <div style={{ marginTop: '-25px', float: 'right' }} className={100 < namelength ? 'danger-text' : ''}>{namelength}/100 char used</div>

                                    <Form.Item
                                        name="email"
                                        label="Email Address"
                                        rules={[
                                            { required: true, message: 'Please input your email address' },
                                            { type: 'email', message: 'Please validate your email address' },
                                            { max: 100, message: "The maximum length for the email is 100 characters." }
                                        ]}
                                        initialValue={editData ? editData.email : ''}
                                    >
                                        <Input placeholder="name@example.com" />
                                    </Form.Item>

                                    <Row gutter={15}>
                                        <Col md={12} className="mb-25">
                                            <Form.Item name="phone" label="Phone"
                                                rules={[{ required: true, message: 'Please input your phone' }]}
                                                initialValue={phone ? phone : ''}
                                            >
                                                <PhoneInput
                                                    country={'us'}
                                                    inputProps={{
                                                        name: 'phone'
                                                    }}
                                                    inputStyle={{
                                                        height: '48px',
                                                        width: '100%'
                                                    }}
                                                    enableSearch={true}
                                                    copyNumbersOnly={false}
                                                    searchPlaceholder='search'
                                                    searchNotFound='No entries to show'
                                                    countryCodeEditable={false}
                                                    onChange={handleCountryCode}
                                                    value={phone ? phone : ''}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col md={12} className="mb-25">
                                            <Form.Item name="city" label="City" rules={[{ required: true, message: 'Please select your city' }]}
                                                tooltip={{
                                                    title: <p dangerouslySetInnerHTML={{ __html: snippetData != "" ? snippetData.CityContent : "Currently we are only in the Chicago area, please send us a message if you think your location would be a good fit for Stoodio." }}></p>,
                                                    icon: <FeatherIcon icon="help-circle" size={20} />,
                                                    overlayClassName: 'ant-tooltip-custom-width'
                                                }}
                                                initialValue={editData ? editData.city : ''}
                                            >
                                                <Input placeholder="City name" />
                                            </Form.Item>

                                        </Col>
                                    </Row>



                                    <Row gutter={15}>
                                        <Col md={12} className="mb-25">
                                            <Form.Item
                                                label="Password"
                                                name="password"
                                                rules={[{ required: true, message: 'Please input your password' }]}
                                                initialValue={editData ? editData.password : ''}
                                            >
                                                <Input.Password placeholder="Password" />
                                            </Form.Item>
                                        </Col>
                                        <Col md={12} className="mb-25">
                                            <Form.Item
                                                name="confirm"
                                                label="Confirm Password"
                                                dependencies={['password']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please confirm your password',
                                                    },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('password') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error('Your password entered do not match'));
                                                        },
                                                    }),
                                                ]}
                                                initialValue={editData ? editData.password : ''}
                                            >
                                                <Input.Password />
                                            </Form.Item>

                                        </Col>
                                    </Row>

                                    <Form.Item
                                        label="Bio"
                                        name="bio"
                                        rules={[
                                            { max: 5000, message: "The maximum length for the bio is 5000 characters." }]}
                                        initialValue={editData ? editData.bio : ''}
                                    >
                                        <Input.TextArea rows={4} type='text' onChange={(e) => assign_bio(e.target.value)} />
                                    </Form.Item>
                                    <div style={{ marginTop: '-25px', float: 'right' }} className={5000 < biolength ? 'danger-text' : ''}>{biolength}/5000 char used</div>




                                    <Form.Item>

                                        <Button type="primary" htmlType="submit" disabled={buttonDisable}>
                                            Submit {loading && (<i className='fa fa-spinner fa-spin' style={{ fontSize: 18, marginLeft: 5 }} />)}
                                        </Button>
                                        {' '}
                                        <Button size="default" type="white" key="back" outlined onClick={handleCancel}>
                                            Cancel
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </BasicFormWrapper>
                        </>}

                </div>
            </Modal>
        </>
    );
};

EditMerchant.propTypes = {
    visible: propTypes.bool.isRequired,
    onCancel: propTypes.func.isRequired,
};

export default EditMerchant;
